import type { ThreadDto } from "../dtos/threadDto";

export const fromDto = (thread: ThreadDto) => {
  return {
    id: thread.id,
  };
};
